// widgetLabel — turns a craft.js block `displayName` (the INTERNAL name, e.g.
// "CarouselWidget") into the human label the block editor pane shows.
//
// WHY THIS EXISTS (QA-46, reported by Kelly 2026-07-31): `getWidgetDetails` in
// utils/helpers.js enumerates a block per `switch` case, and every block added
// after that switch was written — Carousel, Title Bar, Poll, Form, Graph,
// Accordion, Button — fell through to the default, which returned the raw
// displayName. The editor pane therefore read "CarouselWidget" instead of
// "Carousel" (measured on web-stg, bundle main.34fb621d.js). Deriving the label
// instead of enumerating it fixes every current block AND every future one, so
// the same papercut cannot come back with the next block type.
//
// Lives in its own dependency-free module (same precedent as utils/caseConvert.js)
// so tests can import it without pulling in helpers.js's heavy transitive graph.

/**
 * "CarouselWidget"  -> "Carousel"
 * "TitleBarWidget"  -> "Title Bar"
 * "ImageWithText"   -> "Image With Text"
 * "Table"           -> "Table"
 * @param {string} widgetName craft.js displayName
 * @returns {string} human-readable block label
 */
export const prettifyWidgetName = (widgetName) =>
  String(widgetName == null ? "" : widgetName)
    .replace(/Widget$/, "")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .trim();

export default prettifyWidgetName;
